export const DEFAULT_VALUES = {
    CARD_PAYMENT : 3.2,
    CUSTOMER_PHONE_NO: 1111111111
}